// src/communaute/NotificationsPage.jsx
//
// Page « Notifications » du dashboard créateur.
// Affiche la liste (Notifications.jsx) et route chaque clic vers la
// bonne page — équivalent web de NotificationRouter.dart côté app :
//
//   evenement              → fiche événement
//   message / groupe       → messagerie, conversation ouverte directement
//   post                   → publication ouverte dans une modale
//   commentaire / like     → publication ouverte, commentaires dépliés
//   abonnement             → page abonnement
//   follow                 → pas de fiche « profil public » sur le
//                             dashboard web pour l'instant → ignoré
//
// Utilisation (react-router) :
//   <Route path="/notifications" element={<NotificationsPage />} />

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';

import { getPost } from './api';
import Notifications from './Notifications';
import PostCard from './PostCard';
import { Chargement, Modal, UiHost, Vide } from './ui';

export default function NotificationsPage() {
    const navigate = useNavigate();
    const [postCible, setPostCible] = useState(null); // { id, commentaires }

    const ouvrir = (n) => {
        switch (n.type) {
            case 'evenement':
                if (n.targetId) navigate(`/EspaceClient/mesevents/view/${n.targetId}`);
                break;

            case 'message':
            case 'groupe':
                if (n.targetId) {
                    navigate('/EspaceClient/messagerie', { state: { convInitialeId: n.targetId } });
                }
                break;

            case 'post':
                if (n.targetId) setPostCible({ id: n.targetId, commentaires: false });
                break;

            case 'commentaire':
            case 'like':
                if (n.targetId) setPostCible({ id: n.targetId, commentaires: true });
                break;

            case 'abonnement':
                navigate('/EspaceClient/abonnement');
                break;

            case 'follow':
            default:
                // Pas de fiche « profil public » côté dashboard web pour l'instant.
                break;
        }
    };

    return (
        <div className="text-gray-900">
            <Notifications onOuvrir={ouvrir} />

            {postCible && <PostModal cible={postCible} onFermer={() => setPostCible(null)} />}
            <UiHost />
        </div>
    );
}

// ══════════════════════════════════════════════════════
//  PUBLICATION OUVERTE DEPUIS UNE NOTIFICATION
// ══════════════════════════════════════════════════════
function PostModal({ cible, onFermer }) {
    const [post, setPost] = useState(undefined);

    useEffect(() => {
        let annule = false;
        getPost(cible.id).then((p) => !annule && setPost(p));
        return () => {
            annule = true;
        };
    }, [cible.id]);

    return (
        <Modal ouvert onFermer={onFermer} titre="Publication" taille="lg">
            <div className="p-4">
                {post === undefined ? (
                    <Chargement />
                ) : post === null ? (
                    <Vide icone={FileText} titre="Publication introuvable" sous="Elle a peut-être été supprimée" />
                ) : (
                    <PostCard post={post} ouvrirCommentaires={cible.commentaires} onSupprime={onFermer} />
                )}
            </div>
        </Modal>
    );
}